import * as React from 'react';
import { connect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';
import { IOwnBannerProps, IStateBannerProps } from './container';
import { ADFOX_LAZY_LOAD, BANNER_SIZES } from './constants';
import { useAdFoxParams } from './hooks';

const AdFoxBanner = connect(AdFoxTemplates);

type TProps = IStateBannerProps & IOwnBannerProps;

export const Banner = ({
  key,
  regionId,
  userIsAgent,
  className,
  selectedRoads,
  selectedStations,
  placement,
}: TProps) => {
  const adFoxParams = useAdFoxParams({ regionId, userIsAgent, selectedStations, selectedRoads, placement });

  const AdFoxBannerWithPostView = React.useMemo(() => {
    if (!adFoxParams) {
      return null;
    }

    return withAdfoxPostViewAnalytics(
      AdFoxBanner,
      {
        params: adFoxParams,
        lazyLoad: ADFOX_LAZY_LOAD,
        ...BANNER_SIZES,
      },
      {
        banner: {
          place: 'ListingKP',
          name: 'ListingKP_Footer_TGB',
        },
      },
    );
  }, [adFoxParams]);

  if (!AdFoxBannerWithPostView) {
    return null;
  }

  return (
    <div key={key} className={className}>
      <AdFoxBannerWithPostView />
    </div>
  );
};
